var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { IsArray, IsBoolean, IsOptional, IsString, IsUUID, MaxLength, ValidateNested, } from 'class-validator';
import { CreateCustomFormElementDto } from './create-custom-form-element.dto.js';
import { CreateCustomFormSectionDto } from './create-custom-form-section.dto.js';
export class CreateCustomFormDto {
    title;
    description;
    visibleForPatients;
    isDefaultForm;
    officeId;
    /**
     * Flat elements (legacy path). When `createCustomFormSections` is absent
     * these are placed in the form's default "Abschnitt 1" section.
     */
    createCustomFormElements;
    /**
     * Nested sections (section-aware path). When present it takes precedence
     * over `createCustomFormElements`.
     */
    createCustomFormSections;
}
__decorate([
    IsString(),
    MaxLength(255),
    __metadata("design:type", String)
], CreateCustomFormDto.prototype, "title", void 0);
__decorate([
    IsString(),
    MaxLength(255),
    __metadata("design:type", String)
], CreateCustomFormDto.prototype, "description", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], CreateCustomFormDto.prototype, "visibleForPatients", void 0);
__decorate([
    IsOptional(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], CreateCustomFormDto.prototype, "isDefaultForm", void 0);
__decorate([
    IsUUID(),
    __metadata("design:type", String)
], CreateCustomFormDto.prototype, "officeId", void 0);
__decorate([
    IsArray(),
    IsOptional(),
    ValidateNested({ each: true }),
    Type(() => CreateCustomFormElementDto),
    __metadata("design:type", Array)
], CreateCustomFormDto.prototype, "createCustomFormElements", void 0);
__decorate([
    IsArray(),
    IsOptional(),
    ValidateNested({ each: true }),
    Type(() => CreateCustomFormSectionDto),
    __metadata("design:type", Array)
], CreateCustomFormDto.prototype, "createCustomFormSections", void 0);
//# sourceMappingURL=create-custom-form.dto.js.map